export const Manifesto = () => {
  return (
    <section
      id="manifesto"
      data-testid="manifesto"
      className="relative mx-auto w-full max-w-[1400px] px-6 pt-12 pb-10 md:px-10 md:pt-32 md:pb-16"
    >
      <div className="grid grid-cols-12 gap-8">
        <div className="col-span-12 md:col-span-4">
          <span className="font-mono-stamp text-xs text-[#a0a0a0]">
            § 01 · MANIFESTO
          </span>
          <h2 className="font-display mt-6 text-5xl leading-[0.88] md:text-6xl">
            FLIP
            <br />
            THE
            <br />
            <span className="text-outline">SCRIPT.</span>
          </h2>
        </div>

        <div className="col-span-12 grid gap-10 md:col-span-8 md:grid-cols-2">
          <div>
            <p className="font-mono-stamp text-xs text-[#a0a0a0]">▸ THE PROBLEM</p>
            <p className="mt-4 font-display-medium text-2xl leading-tight md:text-3xl">
              "You're a bas1c bitch." Said like it's a dig.
            </p>
            <p className="mt-4 font-mono-stamp text-xs leading-relaxed text-[#a0a0a0]">
              BAS1C CAME TO MEAN UNORIGINAL. MAINSTREAM. PREDICTABLE. LIKE
              WANTING SIMPLE, WELL-MADE THINGS WAS SOMETHING TO APOLOGISE FOR.
            </p>
          </div>

          <div>
            <p className="font-mono-stamp text-xs text-[#a0a0a0]">▸ THE FLIP</p>
            <p className="mt-4 font-display-medium text-2xl leading-tight md:text-3xl">
              Bas1c is not a compromise. It's a choice.
            </p>
            <p className="mt-4 font-mono-stamp text-xs leading-relaxed text-[#a0a0a0]">
              BAS1C IS THE PIECES YOU REACH FOR EVERY DAY — BUT BETTER. CLASSIC
              CUTS. FITS BUILT FOR BODIES, NOT GENDERS.
            </p>
          </div>

          <div className="col-span-full mt-4 border-t border-[#333] pt-8">
            <p className="font-display text-4xl leading-[0.9] md:text-6xl">
              OWN YOUR BAS1C.
              <br />
              <span className="text-outline">RUN YOUR WORLD.</span>
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};
